enum ViewType {
  GRID = "grid",
  LIST = "list",
}

export default ViewType;
